import React, { useState, useEffect } from 'react';
// import './index.scss';
import LeftPanel from '../../user/left-panel';
import RightPanel from '../../user/right-panel';
import { Layout, theme } from 'antd';
import { useParams } from 'react-router-dom';
import {
  ProfilePictureContext,
  UserDesignationDataContext,
  UserProfileDataContext,
} from '../../../../context';
import { useGetProfileDataByAdmin } from '../../../../hooks/GetProfileData';
import styles from './styles.module.scss';

const { Header, Content, Footer, Sider } = Layout;

const UserDetail: React.FC = (): JSX.Element => {
  const { employeeId } = useParams();
  const [
    userProfileData,
    setUserProfileData,
    userDesignationData,
    setUserDesignationData,
    userProfilePictureData,
    setUserProfilePictureData,
  ] = useGetProfileDataByAdmin(employeeId);

  return (
    <>
      <UserProfileDataContext.Provider
        value={{ userProfileData, setUserProfileData }}
      >
        <UserDesignationDataContext.Provider
          value={{ userDesignationData, setUserDesignationData }}
        >
          <ProfilePictureContext.Provider
            value={{ userProfilePictureData, setUserProfilePictureData }}
          >
            <Layout className={styles.layout}>
              <LeftPanel />
              <RightPanel />
            </Layout>
          </ProfilePictureContext.Provider>
        </UserDesignationDataContext.Provider>
      </UserProfileDataContext.Provider>
    </>
  );
};

export default UserDetail;
